(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-draw-result-from-current-wager-draw.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-draw-result-from-current-wager-draw.js');
"use strict";

const _React = React,
  useMemo = _React.useMemo;
const useGetCurrentWagerProductInfo = svs.components.tipsen.hooksWager.useGetCurrentWagerProductInfo;
const useDrawResults = svs.components.tipsen.hooks.useDrawResults;
const useDrawResultFromCurrentWagerDraw = _ref => {
  let wagerId = _ref.wagerId;
  const _useGetCurrentWagerPr = useGetCurrentWagerProductInfo({
      wagerId
    }),
    productId = _useGetCurrentWagerPr.productId,
    drawNumber = _useGetCurrentWagerPr.drawNumber;
  const result = useDrawResults({
    productId,
    drawNumber
  });
  return useMemo(() => [result, drawNumber], [result, drawNumber]);
};
setGlobal('svs.components.tipsen.hooksWager.useDrawResultFromCurrentWagerDraw', useDrawResultFromCurrentWagerDraw);

 })(window);